import { createMuiTheme } from 'material-ui/styles';
import blueGrey from 'material-ui/colors/blueGrey';

export default createMuiTheme({

  palette: {
    type: 'dark',
    primary: blueGrey
  },

  qborder: {
    background: {
      hover: 'rgba(255, 255, 255, 0.12)',
      flash: 'rgba(255, 255, 255, 0.3)',
      code: 'rgba(255, 255, 255, 0.1)'
    }
  },

  overrides: {

    MuiTooltip: {

      tooltipBottom: {
        margin: '0 !important'
      }

    },

    MuiBackdrop: {

      root: {
        zIndex: '0'
      }

    },

    MuiTable: {

      root: {
        overflow: 'auto'
      }

    },

    MuiTableRow: {

      root: {
        height: '32px'
      },

      typeHead: {
        height: '32px'
      }

    }


  }

});




// WEBPACK FOOTER //
// ./src/shared/themes/dark.js